import get from "lodash/get"
import isFunction from "lodash/isFunction"

import { closeBrowser } from "web2ClientAPI/web2ClientAPI"

export const checkReduxStorage = () => {
  // clear searchHistory with old structure before store create
  const reduxStorage = JSON.parse(localStorage.getItem('redux'))
  if (get(reduxStorage, 'searchHistory.items')) {
    localStorage.clear()
  }
}

export const initEventListeners = () => {
  const TAB_KEYCODE = 9
  let lastKeyCode
  document.body.addEventListener('keydown', e => {
    // work around in-game browser sending two keydown events for each keypress,
    // one with invalid keycode
    if (e.keyCode === 0 && lastKeyCode === TAB_KEYCODE) {
      e.preventDefault()
    } else {
      lastKeyCode = e.keyCode
    }
  }, true)

  document.addEventListener('keydown', e => {
    if (e.keyCode === 27 && !e.defaultPrevented) {
      closeBrowser()
    }
  })
  // @ts-ignore
  document.body.onselectstart = event => ['INPUT', 'TEXTAREA'].includes(event.target.nodeName) && ['text', 'textarea'].includes(event.target.type)
}

export const isBrowserSupportsFeatures = () => {
  return isFunction(window.Promise) && isFunction(window.matchMedia)
}